import { useState } from 'react';
import '@/App.css';
import { SvgDefs, PhilosophyPopup, AnimatePresence } from './components/hawelo/Shared';
import { Header, CartDrawer, BottomTabs } from './components/hawelo/HeaderCart';
import { HomePage, Footer } from './components/hawelo/Home';
import { ProductPage, CollectionsPage } from './components/hawelo/Pages';
import { CartProvider, useCart } from './lib/useCart';

function Shell() {
  const [page, setPage] = useState('home'); // home | collections | product
  const [activeHandle, setActiveHandle] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [activePhilosophy, setActivePhilosophy] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { count } = useCart();

  const openProduct = (handle) => {
    setActiveHandle(handle);
    setPage('product');
    window.scrollTo({ top: 0 });
  };
  const goCollections = () => { setPage('collections'); window.scrollTo({ top: 0 }); };
  const goHome = () => { setPage('home'); window.scrollTo({ top: 0 }); };

  return (
    <div className="hawelo-app" data-testid="hawelo-app">
      <SvgDefs />
      <Header
        currentPage={page}
        goHome={goHome}
        goCollections={goCollections}
        openCart={() => setCartOpen(true)}
        onLogoPartClick={setActivePhilosophy}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      {page === 'home' && (
        <HomePage onOpen={openProduct} goCollections={goCollections} />
      )}
      {page === 'collections' && (
        <CollectionsPage onOpen={openProduct} />
      )}
      {page === 'product' && (
        <ProductPage
          handle={activeHandle}
          onOpen={openProduct}
          goCollections={goCollections}
          openCart={() => setCartOpen(true)}
        />
      )}

      <Footer
        onNav={(target) => {
          if (target === 'collections') goCollections();
          else if (target === 'home') goHome();
        }}
      />

      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />

      <BottomTabs
        currentPage={page}
        goHome={goHome}
        goCollections={goCollections}
        openCart={() => setCartOpen(true)}
        cartCount={count}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      <AnimatePresence>
        {activePhilosophy && (
          <PhilosophyPopup
            part={activePhilosophy}
            onClose={() => setActivePhilosophy(null)}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <Shell />
    </CartProvider>
  );
}

export default App;
